export default class RandomLengthPricingRepo {
	constructor({ to, supaTo, supabaseClientFactory, _ }) {
		this.to = to;
		this.supaTo = supaTo;
		this.supabase = supabaseClientFactory;
		this._ = _;
	}

	async createPricing(pricing) {
		if (!pricing) {
			throw new Error('pricing is required to create a new pricing');
		}

		const [err] = await this.supaTo(
			this.supabase.from('material_pricing').insert(pricing),
		);

		if (err) {
			throw err;
		}
	}

	async getAllRandomLengthsPricing() {
		const [err, response] = await this.supaTo(this.supabase.rpc('get_latest_random_length_pricing'));

		if (err) {
			throw err;
		} else {
			return response.data;
		}
	}
}
